import PropTypes from "prop-types";
import {capitaliseFirst,you} from "./__strings";

export default function properties(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    return {
        name: `properties-${props.applicant}`,
        title: "Other Properties",
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' other properties',
        link: `apply-${props.applicant}/properties`,
        defaultLabel: "Property",
        dynamicLabel: "address",
        props: props,
        questions: [
            propertyType(props),
            address(props),
            estimatedValue(props),
            bedrooms(props),
            bathrooms(props),
            isRented(props),
            rentPerAnnum(props),
            isMortgaged(props),
            lender(props),
            outstanding(props),
            monthlyRepayments(props),
            remainingTerm(props),
            restructured(props),
            inArrears(props),
            arrears(props),
        ]
    }
}

export function propertyType(props) {
    return {
        label: "Property Type",
        text: "What type of property is this?",
        name: "propertyType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Detached",
                    value: "DETACHED"
                },
                {
                    text: "Semi-detached",
                    value: "SEMIDETACHED"
                },
                {
                    text: "Terrace",
                    value: "TERRACE"
                },
                {
                    text: "Apartment",
                    value: "APARTMENT"
                },
                {
                    text: "Flat",
                    value: "FLAT"
                }
            ]
        },
        model: "properties"
    }
}
export function address(props) {
    return {
        text: "What is the address of the property?",
        name: "address",
        label: "Address",
        answer: {
            type: "address",
        },
        model: "properties"
    }
}
export function bathrooms(props) {
    return {
        label: "Bathrooms",
        text: "How many bathroom has the property?",
        name: "bathrooms",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 10, message: "10 is the maximum here"}
            }
        },
        model: "properties"
    }
}
export function bedrooms(props) {
    return {
        label: "Bedrooms",
        text: "How many bedrooms has the property?",
        name: "bedrooms",
        answer: {
            type: "int",
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 10, message: "10 is the maximum here"}
            }
        },
        model: "properties"
    }
}
export function estimatedValue(props) {
    return {
        label: "Estimated Value",
        text: "What is the estimated value of the property?",
        name: "estimatedValue",
        answer: {
            type: "euro",
            validation: {
                min: {value: 60000, message: "This must be a value greater than €60,000"},
                max: {value: 1000000, message: "This must be a value less than €1,000,000"}
            }
        },
        model: "properties"
    }
}
export function isRented(props) {
    return {
        text: "Is this property rented out?",
        label: "Rented",
        name: "isRented",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "properties"
    }
}
export function rentPerAnnum(props) {
    return {
        label: "Rent per annum",
        text: "How much rent does the property yield per year?",
        name: "rentPerAnnum",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            isRented: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
export function isMortgaged(props) {
    return {
        text: "Is there a mortgage on the property?",
        label: "Mortgaged",
        name: "isMortgaged",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        model: "properties"
    }
}
export function outstanding(props) {
    return {
        label: "Mortgage Balance",
        text: "What is the balance of the mortgage on this property?",
        name: "outstanding",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
export function monthlyRepayments(props) {
    return {
        text: "What are the monthly repayments?",
        label: "Monthly Repayments",
        name: "monthlyRepayments",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
export function remainingTerm(props) {
    return {
        text: "How many years until fully repaid?",
        label: "Remaining Term",
        name: "remainingTerm",
        answer: {
            type: "int",
            props: {
                maxLength: 2
            },
            validation: {
                min: {value: 1, message: "This must be a value greater than 1"},
                max: {value: 50, message: "50 is the maximum here"}
            }
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
export function lender(props) {
    return {
        text: "Who provided this mortgage?",
        label: "Lender",
        name: "lender",
        answer: {
            type: "text",
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
};
export function inArrears(props) {
    return {
        text: "Is the mortgage currently in arrears?",
        label: "Arrears",
        name: "inArrears",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
export function arrears(props) {
    return {
        text: "By how much are you in arrears?",
        label: "Arrears amount",
        name: "arrears",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 10000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            isMortgaged: (v) => {
                return v !== true
            },
            inArrears: (v) => {
                return v !== true
            }

        },
        model: "properties"
    }
};
export function restructured(props) {
    return {
        text: "Has this loan ever been restructured?",
        label: "Restructured",
        name: "isRestructured",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Yes",
                    value: true
                },
                {
                    text: "No",
                    value: false
                }
            ]
        },
        hides:{
            isMortgaged: (v) => {
                return v !== true
            }
        },
        model: "properties"
    }
}
properties.propTypes = {
    applicant: PropTypes.number
};
